import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { ACCOUNT_REPORT_ID } from './accountReportId';

const emptyColumns = [FIELDS.ACCOUNT_ID, FIELDS.ACCOUNT_DESCRIPTION].map(createFooterMapper(ACCOUNT_REPORT_ID));

const accountReportFooterColumnDefinition = [...emptyColumns];

export default accountReportFooterColumnDefinition;
